<template>
  <v-simple-table
    class="align-start overflow-x: scroll"
    wide
    v-if="average != 'N/A'"
  >
    <thead>
      <tr style="font-size: 1.5em">
        <td colspan="4"></td>
        <td colspan="2">Weighted Average Calculations</td>
      </tr>
      <tr>
        <th>Date</th>
        <th>Assesment and Evaluation</th>
        <th>Score</th>
        <th>Type</th>
        <th>Points Possible</th>
        <th>Points Earned</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="score in scores" :key="score.id">
        <td>{{ new Date(score.date).toLocaleDateString() }}</td>
        <td>{{ score.name }}</td>
        <td v-if="score.score === false || score.score === '' || score.score === null ">Not Scored</td>
        <td v-else class="d-flex justify-end">
          <span
            :class="
              score.excluded ? 'text-decoration-line-through' : ''
            "
          >
            {{ score.score }} out of {{ score.possible }}
          </span>
          <v-chip color="primary lighten-2">
            {{
              Math.round((100 * score.score) / score.possible)
            }}%
          </v-chip>
          <v-tooltip right v-if="score.comment">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on">
                <v-icon small>mdi-flag</v-icon>
              </v-btn>
            </template>
            <span>{{ score.comment }}</span>
          </v-tooltip>
        </td>
        <td>{{ score.type ? score.type.split("(")[0] : "" }}</td>
        <td
          :class="score.score !== false && score.excluded ? 'text-decoration-line-through' : ''"
        >
          {{ score.weight }}
        </td>
        <td v-if="score.score === false">Not Scored</td>
        <td
          v-else
          :class="score.excluded ? 'text-decoration-line-through' : ''"
        >
          {{ getPoint(score) }}
        </td>
      </tr>
      <tr style="font-size: 1.5em">
        <td colspan="6"></td>
      </tr>
      <tr>
        <td></td>
        <td>Current Total</td>
        <td></td>
        <td></td>
        <td>{{ weights.reduce((w, t) => (t += w), 0) }}</td>
        <td>
          {{ Math.round(10 * points.reduce((p, t) => (t += p), 0)) / 10 }}
        </td>
      </tr>
      <tr style="font-size: 1.5em">
        <td></td>
        <td>Current Average</td>
        <td></td>
        <td></td>
        <td colspan="2">
          <v-chip :color="averageRange(average)[0]" text-color="white">
            {{ averageRange(average)[1] }}
          </v-chip>
          {{ average }}% ({{
            Math.round(10 * points.reduce((p, t) => (t += p), 0)) / 10
          }}
          / {{ weights.reduce((w, t) => (t += w), 0) }})
        </td>
      </tr>
    </tbody>
  </v-simple-table>
  <div v-else>
    <v-chip color="primary" class="mt-6"> The course is not graded for the current grading period yet </v-chip>
  </div>
</template>
<script>
export default {
  props: {
    scores: {
      type: Array,
      required: true,
    },
    average: {
      type: String,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    weights() {
      return this.scores
        .filter((s) => s.score !== "" && !s.excluded)
        .map((s) => s.weight);
    },
    points() {
      return this.scores
        .filter((s) => s.score !== "" && !s.excluded)
        .map((s) => this.getPoint(s));
    },
  },
  methods: {
    averageRange(average) {
      let a = Number(average);
      if (a < 65) {
        return ["red", "FAIL"];
      }
      if (65 <= a && a <= 74) {
        return ["orange", "PASS"];
      }
      if (75 <= a && a <= 84) {
        return ["yellow", "GOOD WORK"];
      }
      if (85 <= a && a <= 94) {
        return ["green", "GREAT"];
      }
      if (a > 94) {
        return ["purple", "EXCELLENT"];
      }
      return ["", ""];
    },
    getPoint(score) {
      return score.score === ''
        ? false
        : Math.round((10 * score.score * score.weight) / score.possible) /
            10;
    },
  },
};
</script>
